import React, { useState, useEffect, useRef, useCallback } from "react";

import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";

import Loading from "../../../Loading/Loading";
import Snackbar from "../../../../Snackbar";
import LoadingButton from "../../../Loading/LoadingButton";
import { createRazorpayLinkedAccTempEntry } from "../../../../store/actions/CreateApp/getAllBusinessTypes";
const BusinessAddressLA = ({setNextStep}) => {
    
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [response, setResponse] = useState(null);
  
const [address, setAddress] = useState({
    address_line1: "",
    address_line2: "",
    city: "",
    state: "",
    postal_code: "",
    country: "India",
  });

  // Sync incoming response.accData when it becomes available
  useEffect(() => {
    if (response) {
      setAddress(prev => ({
        ...prev,
        // only update keys that exist in accData (safe merge)
        address_line1: response.accData.address_line1 ?? prev.address_line1,
        address_line2: response.accData.address_line2 ?? prev.address_line2,
        city: response.accData.city ?? prev.city,
        state: response.accData.state ?? prev.state,
        postal_code: response.accData.postal_code ?? prev.postal_code,
        country: response.accData.country ?? prev.country,
      }));
    }
  }, [response]);


  // refs for debounce timer, abort controller, and cache
  const debounceRef = useRef(null);
  const abortRef = useRef(null);
  const cacheRef = useRef(new Map());
  const [animate, setAnimate] = useState(false);
     
    const dispatch = useDispatch();  
  
    const currentToken = useSelector((state)=>state?.user?.user?.token);
    const user_email = useSelector((state)=>state?.user?.user?.user_email
   );
   const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
   const appId = useSelector((state)=>state?.app?.app?.ID);
   const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
        
   const [snackbarVisible, setSnackbarVisible] = useState(false);
    
    const [snackbarColor, setSnackbarColor] = useState("#958FDA");
    const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
    const showSnackbar = () => {
     setSnackbarVisible(true);
   };
   
    const hideSnackbar = () => {
     setSnackbarVisible(false);
   };
  
       const [loader , setLoader] =useState({status:false});
      const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
          {
            
            dispatch({type: "CURSOR",payload:true  });
        
            dispatch({type: "CURSORTEXT",payload:CursorText})
            dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
            dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
          }
           
          const handleMouseLeave = () => {
            
            dispatch({type: "CURSOR",payload:false})
        
            dispatch({type: "CURSORTEXT",payload:""})
        
            dispatch({type: "CURSORTEXTBG",payload:""})
            dispatch({type: "CURSORTEXTCOLOR",payload:""})
          
        
        } 
    
  // perform the actual fetch (debounced via useEffect below)
  const fetchSuggestions = useCallback(async (q) => {
    const trimmed = q.trim();
    if (trimmed.length <= 2) {
      setSuggestions([]);
      setLoading(false);
      setError(null);
      return;
    }

    // return cached if available
    if (cacheRef.current.has(trimmed)) {
      setSuggestions(cacheRef.current.get(trimmed));
      setLoading(false);
      setError(null);
      return;
    }

    // abort previous request
    if (abortRef.current) {
      abortRef.current.abort();
    }
    const controller = new AbortController();
    abortRef.current = controller;

    setLoading(true);
    setError(null);

    try {
      const url = `https://nominatim.openstreetmap.org/search?format=json&addressdetails=1&limit=7&q=${encodeURIComponent(
        trimmed
      )}`;

      const res = await fetch(url, {
        method: "GET",
        signal: controller.signal,
        // Note: browser forbids setting User-Agent; Nominatim expects a valid referer or email if abused.
        // Keep default fetch headers.
      });

      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
      }

      const data = await res.json();
      // store in cache
      cacheRef.current.set(trimmed, data);
      setSuggestions(data);
    } catch (err) {
      if (err.name === "AbortError") {
        // request was aborted; ignore
        return;
      }
      setError("Failed to fetch suggestions");
      setSuggestions([]);
    } finally {
      setLoading(false);
      abortRef.current = null;
    }
  }, []);

  // debounce effect: triggers fetchSuggestions 300ms after last keystroke
  useEffect(() => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    // small early exit for empty queries
    const trimmed = query.trim();
    if (trimmed.length <= 2) {
      setSuggestions([]);
      setLoading(false);
      setError(null);
      return;
    }

    debounceRef.current = setTimeout(() => {
      fetchSuggestions(trimmed);
    }, 300);

    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, [query, fetchSuggestions]);

  // cleanup on unmount
  useEffect(() => {
    return () => {
      if (abortRef.current) abortRef.current.abort();
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, []);

  const handleSelect = (place) => {
    const { address: addr } = place;
    setAddress({
      address_line1: addr.road || addr.pedestrian || addr.cycleway || "",
      address_line2:
        addr.neighbourhood ||
        addr.suburb ||
        addr.quarter ||
        addr.village ||
        "",
      city: addr.city || addr.town || addr.village || addr.hamlet || "",
      state: addr.state || "",
      postal_code: addr.postcode || "",
      country: addr.country || "India",
    });
    setQuery(place.display_name);
    setSuggestions([]);
  };
  useEffect(()=>{
      fireGetAccountDetails()
     
     },[])


     const fireGetAccountDetails=()=>{
      setLoader({status:true});
          
            const apiData = dispatch(createRazorpayLinkedAccTempEntry({userEmail:user_email,
              editType:"getAccDataByuserId"
              }));
            /* get response as Promise   */
            apiData.then(response => {
              if(response){  
              
                if(response?.accData){
                  
              setResponseMessage(response?.message);
              setSnackbarColor("rgba(144, 202, 249,1)");
           setResponse(response);
          setLoader({status:false});
             }else{
        //       setResponseMessage("Something Went Wrong...");
                
        //       setSnackbarColor("#958FDA");
           
               
        //   setLoader({status:false});
          
        //   setSnackbarVisible(true);
        //   setTimeout(()=>{
            
        //     setSnackbarVisible(false);
           
             
        //   },3000)
             }
                
             
             if(response?.logout){
             
              setResponseMessage("You are Logged Out!!!");
                
              setSnackbarColor("#958FDA");
           
               
          setLoader({status:false});
          
          setSnackbarVisible(true);
          setTimeout(()=>{
            
            setSnackbarVisible(false);
           
             
          },3000)
              setTimeout(()=>{
                dispatch({type:"LOGOUT"});
          
              },3000)
              
            }
          /* resetting Login input Fields */
          
              }else{
                setResponseMessage("Something Went Wrong...");
                
                setSnackbarColor("#958FDA");
             
                 
            setLoader({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)    }
          
            }).catch(error => {
           
              //popup of error Info
              setResponseMessage("Something Went Wrong...");
                
              setSnackbarColor("#958FDA");
           
               
          setLoader({status:false});
          
          setSnackbarVisible(true);
          setTimeout(()=>{
            
            setSnackbarVisible(false);
           
             
          },3000)
              console.error(error);
            });
    
       }



    const handleAddLAAddress=()=>{
        setLoader({status:true});
          
              const apiData = dispatch(createRazorpayLinkedAccTempEntry({address_line1:address?.address_line1,address_line2:address?.address_line2,
                city:address?.city,userEmail:user_email,
                state:address?.state,
                editType:"Address",postal_code:address?.postal_code,country:address?.country
                }));
              /* get response as Promise   */
              apiData.then(response => {
                if(response){  
                 
                  if(response?.accData){
                    
                setResponseMessage(response?.message);
                setSnackbarColor("rgba(144, 202, 249,1)");
             
            
            setLoader({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              setNextStep("Finish",4)
              setSnackbarVisible(false);
             
            },1000)
               }else{
            //     setResponseMessage("Something Went Wrong...");
                  
            //     setSnackbarColor("#958FDA");
             
                 
            setLoader({status:false});
            
            // setSnackbarVisible(true);
            // setTimeout(()=>{
              
            //   setSnackbarVisible(false);
             
               
            // },3000)
               }
                  
               
               if(response?.logout){
               
                setResponseMessage("You are Logged Out!!!");
                  
                setSnackbarColor("#958FDA");
             
                 
            setLoader({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
                setTimeout(()=>{
                  dispatch({type:"LOGOUT"});
            
                },3000)
                
              }
            /* resetting Login input Fields */
            
                }else{
                  setResponseMessage("Something Went Wrong...");
                  
                  setSnackbarColor("#958FDA");
               
                   
              setLoader({status:false});
              
              setSnackbarVisible(true);
              setTimeout(()=>{
                
                setSnackbarVisible(false);
               
                 
              },3000)    }
            
              }).catch(error => {
             
                //popup of error Info
                setResponseMessage("Something Went Wrong...");
                  
                setSnackbarColor("#958FDA");
             
                 
            setLoader({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
                console.error(error);
              });
      
         }
         
  return (
    <div style={{ maxWidth: "520px", margin: "12px auto", fontFamily: "sans-serif" }}>
           {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor}  onClose={hideSnackbar} />
      )} 
     <span style={{display:"flex",justifyContent:"left",marginLeft:"10px"}}>Search Location: </span>
 <div  className="ikcraft_login-input-card ">
      <input
      className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"15px"}}
    type="text"
  name="courseTitle" 
       
        value={query}
        placeholder="Search location..."
        onChange={(e) => setQuery(e.target.value)}
       
      />
</div>
      <div  style={{ position: "relative" }}>
        {loading && (
          <div style={{ margin: "8px 0", fontSize: 13 }}>Searching...</div>
        )}
        {error && (
          <div style={{ margin: "8px 0", color: "crimson", fontSize: 13 }}>
            {error}
          </div>
        )}

        {suggestions.length > 0 && (
          <ul className="CreateCourseStepsOuterTextbox"
            style={{
              borderRadius: 6,
              maxHeight: 170,
              overflowY: "auto",
              padding: 0,
              margin: "6px 0",
              listStyle: "none",
              boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
            }}
          >
            {suggestions.map((s) => (
              <li
                key={s.place_id}
                onClick={() => handleSelect(s)}
                style={{
                  cursor: "pointer",
                  padding: "10px 12px",
                  borderBottom: "1px solid #f2f2f2",display:"flex",justifyContent:"left",marginLeft:"10px"
                }}
              >
                <div style={{ fontSize: 13 }}>{s.display_name}</div>
                
              </li>
            ))}
          </ul>
        )}
      </div>

      <h2 style={{ marginTop: 12 }}>Add Your Institute's Address </h2>
<div  className="formBankDetailsGridThree">
        <div  className="ikcraft_login-input-card ">
    <span style={{display:"flex",justifyContent:"left",marginLeft:"10px"}}>Building Name  </span>
 <input onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"15px"}}
      placeholder={`Building Name `} type="text"
  name="courseTitle"  value={address?.address_line1}
          onChange={(e) =>
            setAddress({ ...address, address_line1: e.target.value })
          } />
 </div>
   <div  className="ikcraft_login-input-card ">
    <span style={{display:"flex",justifyContent:"left",marginLeft:"10px"}}>Street Name </span>
 <input onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"15px"}}
      placeholder={`Street Name `} type="text"
  name="courseTitle"  value={address.address_line2}
          onChange={(e) =>
            setAddress({ ...address, address_line2: e.target.value })
          }/>
 </div>
      </div>
      <div  className="formBankDetailsGridThree">
        <div  className="ikcraft_login-input-card ">
    <span style={{display:"flex",justifyContent:"left",marginLeft:"10px"}}>City </span>
 <input onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"15px"}}
      placeholder={`City `} type="text"
  name="courseTitle"value={address.city}
            onChange={(e) => setAddress({ ...address, city: e.target.value })}
       />
 </div>
        <div  className="ikcraft_login-input-card ">
    <span style={{display:"flex",justifyContent:"left",marginLeft:"10px"}}>State </span>
 <input onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"15px"}}
      placeholder={`State `} type="text"
  name="courseTitle" value={address.state}
            onChange={(e) => setAddress({ ...address, state: e.target.value })}
          />
 </div>
 </div><div  className="formBankDetailsGridTwo">
      
 <div  className="ikcraft_login-input-card ">
    <span style={{display:"flex",justifyContent:"left",marginLeft:"10px"}}>Postal Code </span>
 <input onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"15px"}}
      placeholder={`Postal Code `} type="text"
  name="courseTitle"  value={address.postal_code}
            onChange={(e) =>
              setAddress({ ...address, postal_code: e.target.value })
            } />
 </div><div  className="ikcraft_login-input-card ">
    <span style={{display:"flex",justifyContent:"left",marginLeft:"10px"}}>Country</span>
 <input onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"15px"}}
      placeholder={`Country`} type="text"
  name="courseTitle"   value={address.country}
            onChange={(e) => setAddress({ ...address, country: e.target.value })}
           />
 </div>
       
        
        
      </div>

     
<div align="center" className="buttonsRazorpayLA" style={{position:"absolute",left:"0px",right:"0px",bottom:"0px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"5px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}><button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>setNextStep("addBankDetails",2)}   
   className=" CoursesPreviewTopBtn"  type="submit"
   style={{position:"relative",border:"3px solid rgba(144, 202, 249,1)",color:"rgba(144, 202, 249,1)",width:"140px",cursor:"pointer",zIndex:99999,height:"55px"}} 
 > Back </button>

<button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{handleAddLAAddress()}}  style={{position:"relative",background:"rgba(144, 202, 249,1)",color:"#fff",width:"140px",cursor:"pointer",zIndex:99999,height:"55px"}} 
  className=" CoursesPreviewTopBtn"  type="submit"
 > <><LoadingButton  Load={loader?.status}/> Update Address</></button>
</div>
    </div>
  );
};

export default BusinessAddressLA;
